// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"f4d81771","944":"1583faa8"}[chunkId] + ".chunk.js";
};